import React, { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';
import DisputeCreationModal from './DisputeCreationModal';

const DisputeActionBox = ({
  reservation,
  actorRole = 'renter',
  disabled = false,
  fullWidth = true,
  size = 'small',
  variant = 'outlined',
  color = 'secondary',
  onCreated,
  existingDispute = null
}) => {
  const { t } = useTranslation('disputes');
  const [open, setOpen] = useState(false);

  // Debug: log existing dispute prop to help trace why button isn't switching
  // Remove or disable in production once verified
  // eslint-disable-next-line no-console
  console.debug('DisputeActionBox', { reservationId: reservation?.id, existingDispute });

  if (!reservation) {
    return null;
  }

  // If dispute exists, show 'View' button
  if (existingDispute) {
    const handleViewDispute = () => {
      window.open(`/disputes/${existingDispute.dispute_id || existingDispute.id}`, '_blank');
    };

    const statusLabel = existingDispute?.status ? t(`status.${existingDispute.status}`, existingDispute.status) : t('detail.unknownUser', 'Statut inconnu');

    return (
      <Stack spacing={0.5} sx={{ width: fullWidth ? '100%' : 'auto' }}>
        <Typography variant="caption" color="text.secondary">
          {statusLabel}
        </Typography>
        <Button
          variant={variant}
          startIcon={<VisibilityIcon />}
          size={size}
          fullWidth={fullWidth}
          disabled={disabled}
          color="info"
          onClick={handleViewDispute}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {t('actions.view', 'Consulter le litige')}
        </Button>
      </Stack>
    );
  }

  const label = actorRole === 'owner'
    ? t('actions.ownerLaunch', 'Déclencher un litige propriétaire')
    : t('actions.renterLaunch', 'Contester cette réservation');

  const description = actorRole === 'owner'
    ? t('actions.ownerDescription', 'Blocage du dépôt et ouverture d\'une médiation officielle.')
    : t('actions.renterDescription', 'Faites intervenir le support Krillou pour arbitrer.');

  const handleClose = () => setOpen(false);

  const handleSuccess = (dispute) => {
    onCreated?.(dispute);
    handleClose();
  };

  return (
    <>
      <Stack spacing={0.5} sx={{ width: fullWidth ? '100%' : 'auto' }}>
        <Typography variant="caption" color="text.secondary">
          {description}
        </Typography>
        <Button
          variant={variant}
          startIcon={<GavelIcon />}
          size={size}
          fullWidth={fullWidth}
          disabled={disabled}
          color={color}
          onClick={() => setOpen(true)}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {label}
        </Button>
      </Stack>

      <DisputeCreationModal
        open={open}
        onClose={handleClose}
        reservation={reservation}
        actorRole={actorRole}
        onCreated={handleSuccess}
        existingDispute={existingDispute}
      />
    </>
  );
};

export default DisputeActionBox;
